import AccountsInfoBlock from './AccountsInfoBlock';

export default AccountsInfoBlock;
